import { render, staticRenderFns } from "./2d.vue?vue&type=template&id=41d1d22a&scoped=true&"
import script from "./2d.vue?vue&type=script&lang=js&"
export * from "./2d.vue?vue&type=script&lang=js&"
import style0 from "./2d.vue?vue&type=style&index=0&id=41d1d22a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d1d22a",
  null
  
)

export default component.exports